module.exports = __webpack_public_path__ + "img/check.b49e3595.svg";